var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg24 = function Svg24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.293 7.21a1 1 0 1 1 1.414 1.414l-4.293 4.293 4.293 4.293.068.076a1 1 0 0 1-1.406 1.406l-.076-.068-5-5a1 1 0 0 1 0-1.414z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.293 7.21a1 1 0 1 1 1.414 1.414l-4.293 4.293 4.293 4.293.068.076a1 1 0 0 1-1.406 1.406l-.076-.068-5-5a1 1 0 0 1 0-1.414z"
  })));
};
export default Svg24;